import { render } from "./responsive-box-practice.vue?vue&type=template&id=791b2e32"
import script from "./responsive-box-practice.vue?vue&type=script&lang=js"
export * from "./responsive-box-practice.vue?vue&type=script&lang=js"

import "./responsive-box-practice.vue?vue&type=style&index=0&id=791b2e32&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__